import Webview from '../webview/';
import jsonHandler from '../../vendor/json-handler';

export default jsonHandler(Webview);
